import assetPath from '/app/packages/lebenslauf/articles/src/assets/vorstellungsgespraech-erfolgreich-meistern-tipps-zur-vorbereitung-und-souveraene.jpeg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')